import React, { useState } from 'react';
import styled from 'styled-components';
import HeroCardFaq from '../../../asset/mama/hero-card-faq.png';
import FaqBtnClosed from '../../../asset/svg/mama-page/faq-btn-closed.svg';
import FaqBtnOpen from '../../../asset/svg/mama-page/faq-btn-open.svg';
import { TextElem } from '../../../common/text';
import { SIZE_FONT_ENUM } from '../../../theme/size';
import { HeroCard, HeroCardImage, HeroCardText, MamaTextLogo } from './home/frame/hero';

interface FaqItem {
  questionTid: string;
  answerTid: string;
}

const FAQ_ITEMS: FaqItem[] = [
  {
    questionTid: 'MAMA.FAQ.FAQ_Q1',
    answerTid: 'MAMA.FAQ.FAQ_A1',
  },
  {
    questionTid: 'MAMA.FAQ.FAQ_Q2',
    answerTid: 'MAMA.FAQ.FAQ_A2',
  },
  {
    questionTid: 'MAMA.FAQ.FAQ_Q3',
    answerTid: 'MAMA.FAQ.FAQ_A3',
  },
  {
    questionTid: 'MAMA.FAQ.FAQ_Q4',
    answerTid: 'MAMA.FAQ.FAQ_A4',
  },
  {
    questionTid: 'MAMA.FAQ.FAQ_Q5',
    answerTid: 'MAMA.FAQ.FAQ_A5',
  },
];

export const Faq: React.FC<{}> = ({ }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Container id="faq">
      <WheelSection>
        <WheelSectionInner>
          <WheelTextSide>
            <MamaTextLogo
              color="white"
              size={SIZE_FONT_ENUM.TITLE_LARGE}
              type="extra-bold"
              tid="MAMA.FAQ.TITLE"
            />
            <HeroCardStyled>
              <HeroCardImage src={HeroCardFaq} />
              <HeroCardTextStyled color="white" size="main" tid="MAMA.FAQ.TEXT" />
            </HeroCardStyled>
          </WheelTextSide>
          <WheelVisual $disabled={false}>
            <FaqList>
              {FAQ_ITEMS.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <FaqItemWrapper key={index} $isOpen={isOpen}>
                    <FaqQuestion onClick={() => handleToggle(index)}>
                      <TextElem tid={item.questionTid} />
                      <FaqToggleBtn src={!isOpen ? FaqBtnOpen : FaqBtnClosed} alt={isOpen ? 'close' : 'open'} />
                    </FaqQuestion>
                    {isOpen && (
                      <FaqAnswer>
                        <TextElem tid={item.answerTid} type='bold' fontFamily='RF Dewi' />
                      </FaqAnswer>
                    )}
                  </FaqItemWrapper>
                );
              })}
            </FaqList>
          </WheelVisual>
        </WheelSectionInner>
      </WheelSection>
    </Container>
  );
};

const Container = styled.div`
  max-width: 1400px;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 2;
  margin-bottom: 100px;
`;

// ─── Wheel Section ───────────────────────────────────────────────────────────
const WheelSection = styled.div`
  padding-top: 100px;
  width: 100%;
`;

const WheelSectionInner = styled.div`
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  gap: 32px;
  @media (max-width: 1080px) {
    flex-direction: column;
  }
`;

const WheelTextSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  min-width: 300px;
`;

const WheelVisual = styled.div<{ $disabled: boolean }>`
  flex-shrink: 0;
  max-width: 544px;
  width: 100%;
  align-self: end;
  filter: opacity(${({ $disabled }) => ($disabled ? '0.5' : '1')});
  @media (max-width: 768px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

// ─── FAQ List ────────────────────────────────────────────────────────────────
const FaqList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const FaqItemWrapper = styled.div<{ $isOpen: boolean }>`
  background: linear-gradient(180deg, #FFCD00 48.89%, #F2740C 100%);
  box-shadow: 6px 10px 0px 0px #00000026;

  border-radius: 12px;
  overflow: hidden;
  width: 100%;
`;

const FaqQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: pointer;
  gap: 12px;
`;

const FaqToggleBtn = styled.img`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
`;

const FaqAnswer = styled.div`
  padding: 0 20px 16px 20px;
`;

const HeroCardStyled = styled(HeroCard)`
  text-align: center;

  @media screen and (max-width: 615px) {
    width: 100%;
    text-align: center;

    img {
      height: 110%;
    }

    > span {
      width: 100%
    }
  }
`

const HeroCardTextStyled = styled(HeroCardText)`
  @media screen and (max-width: 615px) {
    /* width: 100%; */
    font-size: 20px;
  }

  @media screen and (max-width: 400px) {
    font-size: 16px;
  } 
`;